import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthenticationWrapper';
import LegalAcceptanceGate from './reusables/legalAcceptanceGate';

const RequireAuth = () => {
  const { isAuthenticated, isLoadingAuth } = useAuth();
  const location = useLocation();

  if (isLoadingAuth) {
    return <div>Carregando autenticação...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      <LegalAcceptanceGate />
      <Outlet />
    </>
  );
};

export default RequireAuth;

